import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminUserRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/users/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/admin/Users/AdminUserPage/AdminUserPage').then((d) => d.Route));
